import { GetState, SetState } from 'zustand';
import { GoalI } from '../../interfaces/GoalInterface';
import axios from 'axios';
import { AppStatesI } from '../interfaces/storeStatesInterface';
import { removeObjFromList, setErrorMessage } from './shareActionFuncs';
import {
  BEHIND,
  COMPLETED,
  GOAL_M_SETTED,
  M_Success,
  ON_PROGRESS,
  S_Goals,
} from '../../common/Types';

// APIs ####################

// development code
const host =
  window.location.host === 'localhost:3000' ? 'localhost' : '192.168.0.144';

export const fetchAllGoalsAPI = async () => {
  return await axios.get(`http://${host}:5000/api/v1/goals/all`);
};

export const createGoalsAPI = async (goal: GoalI) => {
  return await axios.post(`http://${host}:5000/api/v1/goals`, goal);
};

// ACTIONS ####################

export const getAllGoals = async (setState: SetState<AppStatesI>) => {
  try {
    setState({ isLoading: true });
    const res = await fetchAllGoalsAPI();
    var goals: GoalI[] = [];

    if (res.data) {
      goals = res.data;

      setState({ allGoals: goals, isLoading: false });
    } else {
      setErrorMessage(setState, res);
    }
  } catch (err) {
    setErrorMessage(setState, err);
  }
};

export const addGoal = async (
  setState: SetState<AppStatesI>,
  get: GetState<AppStatesI>,
  nGoal: GoalI
) => {
  setState({ isLoading: true });
  setState((_preState) => ({
    allGoals: [..._preState.allGoals, nGoal],
    goal: nGoal,
    isLoading: false,
  }));

  get().addMessage({
    type: M_Success,
    content: GOAL_M_SETTED,
    stateName: S_Goals,
  });

  //   } else {
  //     setErrorMessage(setState, res);
  //   }
  // }
  // catch (err) {
  //   console.log(err);
  //   setErrorMessage(setState, err);
  // };
};

export const updateGoal = (
  setState: SetState<AppStatesI>,
  get: GetState<AppStatesI>,
  nGoal: GoalI
) => {
  setState((_preState) => ({
    allGoals: _preState.allGoals.map((_g) =>
      _g.key === nGoal.key ? nGoal : _g
    ),
  }));
};

export const removeGoal = (
  setState: SetState<AppStatesI>,
  get: GetState<AppStatesI>,
  _rGoal: GoalI
) => {
  setState((_preState) => ({
    allGoals: removeObjFromList(_preState.allGoals, _rGoal, 'key'),
  }));
};

export const updateAllGoalStatus = (
  goalList: GoalI[],
  updateGoal: Function
) => {
  const _curDate = new Date();
  _curDate.setHours(0, 0, 0, 0);

  for (var i in goalList) {
    const _goal = goalList[i];
    const _goalStDate = new Date(_goal.startTime);
    const _goalEnDate = new Date(_goal.endTime);
    _goalStDate.setHours(0, 0, 0, 0);
    _goalEnDate.setHours(0, 0, 0, 0);

    if (_goal.goalStatus !== COMPLETED) {
      if (
        _goalStDate.getFullYear() <= _curDate.getFullYear() &&
        _goalStDate.getMonth() <= _curDate.getMonth() &&
        _goalStDate.getDate() <= _curDate.getDate() &&
        _curDate.getFullYear() <= _goalEnDate.getFullYear() &&
        _curDate.getMonth() <= _goalEnDate.getMonth() &&
        _curDate.getDate() <= _goalEnDate.getDate()
      ) {
        updateGoal({ ..._goal, goalStatus: ON_PROGRESS });
      } else if (
        _curDate.getFullYear() >= _goalEnDate.getFullYear() &&
        _curDate.getMonth() >= _goalEnDate.getMonth() &&
        _curDate.getDate() > _goalEnDate.getDate()
      ) {
        updateGoal({ ..._goal, goalStatus: BEHIND });
      }
    }
  }
};
